// 系统管理页面

import React from 'react';
import { Layout } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import SystemContent from './components/SystemContent';
import { ROLE } from '../services/Macro';
import { checker } from '../utils/Checker';
import { Global } from '../services/Global';
import { browserUtil } from '../utils/BrowserUtil';
import { Page } from '../services/Page';

const { Content } = Layout;

interface SystemViewState {
    loginName: string;
    showWarn: boolean;
    showConfirm: boolean;
    warnTitle: string;
    warnInfo: string;
    fileList: unknown[];
    appList: unknown[];
    confirmOp: () => void;
}

class SystemView extends React.Component<WithTranslation, SystemViewState> {
    state: SystemViewState = {
        loginName: '',
        showWarn: false,
        showConfirm: false,
        warnTitle: '本地错误',
        warnInfo: '参数错误',
        fileList: [],
        appList: [],
        confirmOp: () => undefined,
    };

    componentDidMount() {
        Global.isMobile = browserUtil.checkMobile();
        void this.checkLogin();
    }

    checkLogin = async () => {
        const isLogin = await checker.checkLogin(ROLE.SUPER, Page.system);
        if (isLogin) {
            this.setState({ loginName: 'Admin' });
        }
    };

    openConfirm = (title: string, info: string, op: () => void) => {
        this.setState({
            warnTitle: title,
            warnInfo: info,
            showConfirm: true,
            confirmOp: () => {
                op();
                this.closeConfirm();
            },
        });
    };

    closeConfirm = () => {
        this.setState({ showConfirm: false });
    };

    openWarn = (title: string, info: string) => {
        this.setState({
            warnTitle: title,
            warnInfo: info,
            showWarn: true,
        });
    };

    closeWarn = () => {
        this.setState({ showWarn: false });
    };

    changeLang = () => {
        // 保留原接口，语言切换由 Header 负责。
    };

    render() {
        const { t, i18n } = this.props;

        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={this.state.loginName}
                    changeLang={this.changeLang}
                />

                <Layout>
                    <Sidebar selectMenu="system" trans={t} />

                    <Content>
                        <SystemContent
                            trans={t}
                            handleError={this.openWarn}
                            handleConfirm={this.openConfirm}
                            fileList={this.state.fileList}
                            appList={this.state.appList}
                        />
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export const SystemPage = withTranslation()(SystemView);
export default SystemView;
